import Vue from 'vue'
import Vuex from 'vuex'

import { activity } from '@/store/modules/activity'
import { app } from '@/store/modules/app'
import { client } from '@/store/modules/client'
import { diagnostic } from '@/store/modules/diagnostic'
import { drawer } from '@/store/modules/drawer'
import { groups } from '@/store/modules/groups'
import { history } from '@/store/modules/history'
import { org } from '@/store/modules/org'
import { notification } from '@/store/modules/notification'
import { theme } from '@/store/modules/theme'
import { thing } from '@/store/modules/thing'
import { things } from '@/store/modules/things'
import { user } from '@/store/modules/user'
import { users } from '@/store/modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    activity,
    app,
    client,
    diagnostic,
    drawer,
    groups,
    history,
    notification,
    org,
    theme,
    thing,
    things,
    user,
    users
  }
})
